export type ResponsePriceDto = {
    base: number,
    discount: number,
}

export type ResponseImageDto = {
    mobile: string,
    desktop: string,
    popup: string,
}

export enum ResponseSubscriptionType {
    oneOf = 'oneOf',
    multiple = 'multiple',
}

export type ResponseDto = {
    id: number,
    serviceId: number,
    title: string,
    description: string,
    fullDescription: string,
    price: ResponsePriceDto,
    images: ResponseImageDto,
    type: ResponseSubscriptionType,
}
